
import {Component, Vue} from 'vue-property-decorator'
import MaterialSelect from "@/components/material-select/index.vue";
import LsEditor from "@/components/editor.vue";

import {apiArticleAdd, apiArticleCategoryLists, apiArticleDetail, apiArticleEdit, apiShopLists} from '@/api/shop'
import {debounce} from '@/utils/util'

@Component({
  components: {
    MaterialSelect,
    LsEditor
  }
})
export default class ArticleEdit extends Vue {
  identity: number | null = null;
  shopData: any[] = []
  form: any = {
    sid: '',
    title: '',
    image: '',
    content: '',
    is_show: 1,
    sort: 0,
    upload_time: ''
  };
  categoryList: any[] = []

  rules = {
    sid: [{required: true, message: '请选择商户', trigger: ['blur', 'change']}],
    title: [{required: true, message: '请输入标题', trigger: ['blur', 'change']}],
    image: [{required: true, message: '请上传封面图', trigger: ['blur', 'change']}],
    cid: [{required: true, message: '请选择资讯分类', trigger: ['blur', 'change']}],
    content: [{required: true, message: '请输入内容', trigger: ['blur', 'change']}],
    is_show: [{required: true, message: '请选择是否显示', trigger: ['blur', 'change']}],
    sort: [{required: true, message: '请输入排序', trigger: ['blur', 'change']}],
    upload_time: [{required: true, message: '请选择上传时间', trigger: ['blur', 'change']}]
  };

  onSubmit(formName: string) {
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      if (!this.identity) {
        this.handleAdd()
      } else {
        this.handleEdit()
      }
    })
  }

  async handleAdd(): Promise<void> {
    const formData = {...this.form};
    // 将毫秒时间戳转换为秒级时间戳
    if (formData.upload_time) {
      formData.upload_time = Math.floor(formData.upload_time / 1000);
    }
    await apiArticleAdd(formData)
    setTimeout(() => this.$router.go(-1), 500)
  }

  async handleEdit(): Promise<void> {
    const formData = {...this.form, id: this.identity};
    // 将毫秒时间戳转换为秒级时间戳
    if (formData.upload_time) {
      formData.upload_time = Math.floor(formData.upload_time / 1000);
    }
    await apiArticleEdit(formData)
    setTimeout(() => this.$router.go(-1), 500)
  }

  async getDetailFunc(): Promise<void> {
    const res = await apiArticleDetail({
      id: this.identity as number
    })
    Object.keys(res).map((key) => {
      // 将后端返回的秒级时间戳转换为毫秒级时间戳
      if (key === 'upload_time' && res[key]) {
        this.$set(this.form, key, res[key] * 1000)
      } else {
        this.$set(this.form, key, res[key])
      }
    })
    
    // 如果有商户ID，则获取对应的分类列表
    if (this.form.sid) {
      await this.fetchCategoriesBySid();
    }
  }

  async getShopListsFn(): Promise<void> {
    try {
      const res: any = await apiShopLists({
        page_no: 1,
        page_size: 100,
      })
      this.shopData = res.lists || [];
    } catch (error) {
      console.error('获取商户列表失败:', error)
      this.shopData = [];
    }
  }

  // 根据sid获取分类列表
  async fetchCategoriesBySid(): Promise<void> {
    if (!this.form.sid) {
      this.categoryList = [];
      this.form.cid = ''; // 清空已选择的分类
      return;
    }

    try {
      const res: any = await apiArticleCategoryLists({
        sid: this.form.sid
      })
      this.categoryList = res.lists || []
      // 如果当前选择的分类不在新的分类列表中，则清空选择
      if (this.form.cid && !this.categoryList.some(item => item.id === this.form.cid)) {
        this.form.cid = '';
      }
    } catch (error) {
      console.error('获取分类列表失败:', error)
      this.categoryList = [];
      this.form.cid = '';
    }
  }

  created() {
    const query: any = this.$route.query
    this.identity = +query.id
    if (+query.id) {
      this.getDetailFunc()
    }
    this.getShopListsFn()
  }

  handleShopChange(val: string) {
    this.form.sid = val;
    this.fetchCategoriesBySid();
  }
}
